import { Component } from "react";
import * as React from "react";
import {TeamTemplate} from "../models/CreateSiteForm";
import {Dropdown,IDropdownOption} from "office-ui-fabric-react";


export interface TeamTemplateSelectorProps {
    className: string;
    selectedTeamTemplate: TeamTemplate;
    disabled: boolean;
    onChanged(TeamTemplate: TeamTemplate): void;
}

export interface TeamTemplateSelectorState {
}

const OPTIONS: IDropdownOption[] = [
    {
        text: "Standard",
        key: "standard",
        data: "standard"
    },
    {
        text: "Education Staff",
        key: "educationStaff",
        data: "educationStaff"
    },
    {
        text: "Education PLC (Professional Learning Community)",
        key: "educationProfessionalLearningCommunity",
        data: "educationProfessionalLearningCommunity"
    }
]

export default class TeamTemplateSelector extends Component<TeamTemplateSelectorProps, TeamTemplateSelectorState>
{
    constructor(props: Readonly<TeamTemplateSelectorProps>) {
        super(props);

        this.state = {
        };
    }

    componentDidUpdate(prevProps: Readonly<TeamTemplateSelectorProps>, prevState: Readonly<TeamTemplateSelectorState>, snapshot?: any): void {
    }
    
    public componentDidMount() {
    }

    public render() {
        return (
            <Dropdown
                className={this.props.className}
                label="Team Template"
                disabled={this.props.disabled}
                selectedKey={this.props.selectedTeamTemplate}
                onChange={(e,o) => this.props.onChanged(o?.key as TeamTemplate)}
                placeholder={"Select a Team Template"}
                options={OPTIONS}
                styles={{ dropdown: { width: 300 } }}
            />
        );
    }
}